import React, { MouseEvent, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Popover, Typography, Button, List, ListItem, ListItemText } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import i18n from 'i18next'
import { CrudeContext } from '@3m5/crude-frontend/dist/crudeHooks'
import { LanguageType } from '@3m5/crude-frontend/dist/shared/types/configurationTypes'

import { availableLanguages } from '~shared/translations/i18next'
import { useAppBarItemStyles } from './AppBarItemStyles'

const LanguageSwitcher: React.FC = () => {
  const s = useAppBarItemStyles()
  const { t } = useTranslation()
  const { methods } = useContext(CrudeContext)

  const [anchorEl, setAnchorEl] = React.useState<null | Element>(null)

  const handleOpenPopover = (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => setAnchorEl(event.currentTarget)
  const handleClosePopover = () => setAnchorEl(null)

  const open = Boolean(anchorEl)
  const id = open ? 'LanguageMenuPopover' : undefined

  const handleListItemClick = (lngCode: string) => () => {
    localStorage.setItem('language', lngCode)
    // @ts-ignore - checking if lngCode IS of type LanguageType
    methods?.changeLanguage(lngCode as LanguageType)
    i18n.changeLanguage(lngCode)

    handleClosePopover()
  }

  const languageListItems = availableLanguages.map((language, i) => {
    return <ListItem
      button
      focusRipple
      selected={t('language:code') === language.code}
      onClick={handleListItemClick(language.code)}
      key={i}
    >
      <ListItemText primary={language.name} secondary={language.code} />
    </ListItem>
  })

  return <>
    <Button
      onClick={handleOpenPopover}
      endIcon={<ExpandMoreIcon />}
      color='inherit'
    >
      <Typography className={s.centerButtonText} component='span'>{t('language:codeShort').toUpperCase()}</Typography>
    </Button>

    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClosePopover}
      marginThreshold={30} // Specifies how close to the edge of the window the popover can appear.
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <List dense disablePadding className={s.popoverContainer}>{languageListItems}</List>
    </Popover>
  </>
}

export default LanguageSwitcher
